import { Config } from './config-type'

export const config: Config = {
  SYSTEM_ENV: 'itg',
  GTM_ID: 'GTM-PC6MWTZ',
}